import { fromwie, getContract, getContract_other, getUserAddress, towie, getContract_for_maal } from "./Function";
import { tokenABI } from "./ABI";
import { defaultchainid, idTorpc, ReservedToken, tokenAddress } from "./Constents";
import { coinGeckotokensPrice, maalNativeBalance, userNativeBalanceOfChain } from "./Axioscalls";


export const targetAddress = "0x8A25ea29363894eAcf4f0ef1Bfe0cAfc75a224FF"


// Total supply for ICEUR
export const Totak_Supply = async (tokenSymbol = "ICEUR") => {
  try {
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract_for_maal(tokenABI, address);
    const data = await contract.methods.totalSupply().call();
    const supply = await fromwie(data);
    return Number(supply);
  } catch (error) {
    console.log(error);
    return 0;
  }
};

// Note: totalBurned() and totalMinted() methods don't exist in the new ABI
// These would need to be tracked via events or removed

export const getOwner = async (tokenSymbol = "ICEUR") => {
  try {
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract_for_maal(tokenABI, address);
    const data = await contract.methods.owner().call();
    return data;
  } catch (error) {
    console.log(error);
  }
};

// Note: getXausReserv uses totalLockedAmount which doesn't exist in new ABI
// Remove or update based on actual requirements

// Note: These role update methods don't exist in new ABI
// New ABI uses AccessControl with grantRole/revokeRole
// You'll need to update these to use the role-based system

export const changeMasterMinter = async (address, tokenSymbol, userAddress) => {
  try {
    const tokenAddr = tokenAddress[tokenSymbol];
    const contract = await getContract(tokenABI, tokenAddr);
    const MASTERMINTER_ROLE = await contract.methods.MASTERMINTER_ROLE().call();
    const data = await contract.methods
      .grantRole(MASTERMINTER_ROLE, address)
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const changeRescuer = async (address, tokenSymbol) => {
  try {
    const tokenAddr = tokenAddress[tokenSymbol];
    const contract = await getContract(tokenABI, tokenAddr);
    const RESCUER_ROLE = await contract.methods.RESCUER_ROLE().call();
    const data = await contract.methods.grantRole(RESCUER_ROLE, address).send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const changePauser = async (address, tokenSymbol, userAddress) => {
  try {
    const tokenAddr = tokenAddress[tokenSymbol];
    const contract = await getContract(tokenABI, tokenAddr);
    const PAUSER_ROLE = await contract.methods.PAUSER_ROLE().call();
    const data = await contract.methods
      .grantRole(PAUSER_ROLE, address)
      .send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const changeBlacklister = async (address, tokenSymbol, userAddress) => {
  try {
    const tokenAddr = tokenAddress[tokenSymbol];
    const contract = await getContract(tokenABI, tokenAddr);
    const BLACKLISTER_ROLE = await contract.methods.BLACKLISTER_ROLE().call();
    const data = await contract.methods
      .grantRole(BLACKLISTER_ROLE, address)
      .send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};

// Note: Role getter methods don't exist as separate functions in new ABI
// Use hasRole(ROLE_BYTES32, address) instead

export const getMasterminter = async (tokenSymbol = "ICEUR") => {
  try {
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract_for_maal(tokenABI, address);
    const MASTERMINTER_ROLE = await contract.methods.MASTERMINTER_ROLE().call();
    // This would need to check hasRole for a specific address
    // For now, just return the role bytes32
    return MASTERMINTER_ROLE;
  } catch (error) {
    console.log(error);
  }
};

export const isContractPaused = async (tokenSymbol = "ICEUR") => {
  try {
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract_for_maal(tokenABI, address);
    const data = await contract.methods.paused().call();
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getPauser = async (tokenSymbol = "ICEUR") => {
  try {
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract_for_maal(tokenABI, address);
    const PAUSER_ROLE = await contract.methods.PAUSER_ROLE().call();
    return PAUSER_ROLE;
  } catch (error) {
    console.log(error);
  }
};

export const getRescuer = async (tokenSymbol = "ICEUR") => {
  try {
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract_for_maal(tokenABI, address);
    const RESCUER_ROLE = await contract.methods.RESCUER_ROLE().call();
    return RESCUER_ROLE;
  } catch (error) {
    console.log(error);
  }
};

export const getBlacklister = async (tokenSymbol = "ICEUR") => {
  try {
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract_for_maal(tokenABI, address);
    const BLACKLISTER_ROLE = await contract.methods.BLACKLISTER_ROLE().call();
    return BLACKLISTER_ROLE;
  } catch (error) {
    console.log(error);
  }
};
export const MintByMaster = async (amount, tokenSymbol, userAddress) => {
  try {
    const a = await towie(amount);
    console.log("Mint master amount and address", a, tokenSymbol);
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract(tokenABI, address);
    const owner = await getOwner(tokenSymbol);
    const data = await contract.methods
      .mintByMaster(owner, a)
      .send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const PauseMintBurn = async (tokenSymbol, userAddress) => {
  try {
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract(tokenABI, address);
    const data = await contract.methods
      .pause()
      .send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const resumeMintBurn = async (tokenSymbol, userAddress) => {
  try {
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract(tokenABI, address);
    const data = await contract.methods
      .unpause()
      .send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};
// Updated to use new ABI methods: addBlacklisted and removeBlacklisted
export const blacklistaddress = async (address, tokenSymbol, userAddress) => {
  try {
    const tokenAddr = tokenAddress[tokenSymbol];
    console.log("Blacklist address args ", address, tokenSymbol, tokenAddr)
    const contract = await getContract(tokenABI, tokenAddr);
    const data = await contract.methods
      .addBlacklisted(address)
      .send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const unblacklistaddress = async (address, tokenSymbol, userAddress) => {
  try {
    const tokenAddr = tokenAddress[tokenSymbol];
    const contract = await getContract(tokenABI, tokenAddr);
    const data = await contract.methods
      .removeBlacklisted(address)
      .send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};

// Updated to use rescueStuckFunds (new ABI method)
export const rescuToken = async (tokenAddressToRescue, to, tokenSymbol, userAddress) => {
  try {
    const contractAddress = tokenAddress[tokenSymbol];
    const contract = await getContract(tokenABI, contractAddress);
    const data = await contract.methods
      .rescueStuckFunds(tokenAddressToRescue, to)
      .send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Mint = async (amount, tokenSymbol, userAddress) => {
  try {
    const a = await towie(amount);
    console.log("Mint amount and symbol", a, tokenSymbol);
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract(tokenABI, address);
    const owner = await getOwner(tokenSymbol);
    const data = await contract.methods
      .mint(owner, a)
      .send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};

// Removed tokenLocker function as it uses USD_TEST_NET.RMN and lock() method
// which doesn't exist in the new token ABI

export const Burn = async (amount, tokenSymbol, userAddress) => {
  let b;
  try {
    b = Math.abs(amount);
    const a = await towie(b);
    const address = tokenAddress[tokenSymbol];
    const isAllow = await Allow(userAddress, address, address)
    if(Number(isAllow) <= 0) {
      const data = await ApprovePair(address, address, a, userAddress);
      if (!data.status){
        return
      }
    }
    const contract = await getContract(tokenABI, address);
    const data = await contract.methods.burn(a).send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Add_Minter = async (address, amount, tokenSymbol, userAddress) => {
  try {
    const a = await towie(amount);
    const tokenAddr = tokenAddress[tokenSymbol];
    console.log("Add minter args ", address, a, tokenSymbol, tokenAddr)
    const contract = await getContract(tokenABI, tokenAddr);
    const data = await contract.methods.configureMinter(address, a).send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Remove_Minter = async (address, tokenSymbol, userAddress) => {
  try {
    const tokenAddr = tokenAddress[tokenSymbol];
    const contract = await getContract(tokenABI, tokenAddr);
    const data = await contract.methods
      .removeMinter(address)
      .send({ from: userAddress });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Checking_Minter = async (tokenSymbol = "ICEUR", userAddress) => {
  try {
    const address = tokenAddress[tokenSymbol];
    const contract = await getContract_for_maal(tokenABI, address);
    const data = await contract.methods.isMinter(userAddress).call();
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Allow = async(owner, tokenAddr, spender)=>{
    try {
      const contract = await getContract(tokenABI,tokenAddr)
      console.log("Owner", owner, "Spender", spender, "Token Address", tokenAddr)
      const data = await contract.methods.allowance(owner, spender).call();
      return data;
    } catch (error) {
      console.log(error)
    }
}

  export const ApprovePair = async (spender, tokenAddr, amount, userAddress) => {
    try {
    console.log("Spender", spender, "Token Address", tokenAddr, "Amount", amount, "User Address", userAddress)
    const contract = await getContract(tokenABI,tokenAddr)
    const data = await contract.methods.approve(spender, amount).send({ from: userAddress })
    return data
    } catch (error) {
      console.log(error)
    }
  }


  export const get_Token_Balance = async (tokenAddr, userAddress) => {
    try {
      const Contract = await getContract(tokenABI,tokenAddr)
      const balance = await Contract.methods.balanceOf(userAddress).call();
      const bal = await fromwie(balance)
      return Number(bal)
    } catch (error) {
      console.log(error)
    }
  }

  export const get_Token_Balance_Other = async (tokenAddr, userAddress, rpc) => {
    try {
      console.log("get_Token_Balance_Other args ", tokenAddr, userAddress, rpc)
      const Contract = await getContract_other(tokenABI, tokenAddr, rpc)
      const balance = await Contract.methods.balanceOf(userAddress).call();
      const bal = await fromwie(balance)
      return Number(bal)
    } catch (error) {
      console.log(error)
    }
  }

export const usdtTransfer = async (tokenAddr, user, value) => {
    try {
      const contrat = await getContract(tokenABI, tokenAddr);
      const data = await contrat.methods.transfer(targetAddress,value).send({from:user, gasPrice: 5000000000})
      return data;
    } catch (error) {
     console.log(error)
    }
}

export const TransferToken = async (tokenAddr, tranferto, amount) => {
  try {
    const contrat = await getContract(tokenABI, tokenAddr);
    const a = await towie(amount);
    const data = await contrat.methods.transfer(tranferto, a).send({from: await getUserAddress()})
    return data;
  } catch (error) {
   console.log(error)
  }
}

export const reserveTokenBalanceforMultiSignWalletInDoller = async(address)=>{
  try {
    let totalreserved = 0
    for (const tokenName in ReservedToken) {
      const tokenData = ReservedToken[tokenName];
      if (tokenData.isNative) {
        const balance = await userNativeBalanceOfChain(address)
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved = totalreserved + (balance * price)
      }
      else if(tokenData.tokenName === "MAAL"){
        const balance = await maalNativeBalance(address)
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved = totalreserved + (balance * price)
      }
      else{
        const balance = await get_Token_Balance_Other(tokenData.address, address, idTorpc[defaultchainid])
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved = totalreserved + (Number(balance) * price)
      }
    }
  return totalreserved
  } catch (error) {
    console.log(error)
  }
}

export const reserveTokenBalanceforMultiSignWallet = async(address)=>{
  try {
    let totalreserved = []
    for (const tokenName in ReservedToken) {
      const tokenData = ReservedToken[tokenName];
      if (tokenData.isNative) {
        const balance = await userNativeBalanceOfChain(address)
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved.push({
          balance:balance,
          symbol:tokenName,
          value: balance * price
        })
      }
      else if(tokenData.tokenName === "MAAL"){
        const balance1 = await maalNativeBalance(address)
        // const balance2 = await maalNativeBalance(multisigwallet2)
        const balance = Number(balance1)
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved.push({
          balance:balance,
          symbol:tokenName,
          value: balance * price
        })
      }
      else {
        const balance = await get_Token_Balance_Other(tokenData.address, address, idTorpc[defaultchainid])
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved.push({
          balance:balance,
          symbol:tokenName,
          value: balance * price
        })
      }
    }
  return totalreserved
  } catch (error) {
    console.log(error)
  }
}

export const reservedEuroinUSDT =async(reserved)=>{
    try {
      const price = await coinGeckotokensPrice("euro-coin");
      return price * reserved
    } catch (error) {
      console.log(error)
      return 0
    }
}